import { isNetworkError } from '@portal-packages/api';
import { AxiosError } from 'axios';

import { errorCodeIs } from 'utils/error';
import { StoragePath, getStaticHostURL } from 'utils/static';

import {
  ChangeDeveloperPasswordErrorCodes,
  CreateDeveloperErrorCodes,
  ResetDeveloperPasswordErrorCodes,
  UpdateDeveloperErrorCodes,
} from '../constants';
import { Developer } from '../types';

const isAccountRegisteredError = errorCodeIs(CreateDeveloperErrorCodes.ACCOUNT_ALREADY_REGISTERED);
const isCPFConflictError = errorCodeIs(CreateDeveloperErrorCodes.CPF_ALREADY_IN_USE);
const isCNPJConflictError = errorCodeIs(CreateDeveloperErrorCodes.CNPJ_ALREADY_IN_USE);
const isSlugConflictError = errorCodeIs(CreateDeveloperErrorCodes.SLUG_ALREADY_EXISTS);

export const handleCreateDeveloperError = (error: AxiosError): CreateDeveloperErrorCodes => {
  if (isAccountRegisteredError(error)) {
    return CreateDeveloperErrorCodes.ACCOUNT_ALREADY_REGISTERED;
  }

  if (isCPFConflictError(error)) {
    return CreateDeveloperErrorCodes.CPF_ALREADY_IN_USE;
  }

  if (isCNPJConflictError(error)) {
    return CreateDeveloperErrorCodes.CNPJ_ALREADY_IN_USE;
  }

  if (isSlugConflictError(error)) {
    return CreateDeveloperErrorCodes.SLUG_ALREADY_EXISTS;
  }

  if (isNetworkError(error)) {
    return CreateDeveloperErrorCodes.NET_ERR;
  }

  return CreateDeveloperErrorCodes.UNKNOWN;
};

const isInvalidPasswordError = errorCodeIs(ChangeDeveloperPasswordErrorCodes.INCORRECT_CURRENT_PASSWORD);

export const handleChangeDeveloperPasswordError = (error: AxiosError): ChangeDeveloperPasswordErrorCodes => {
  if (isInvalidPasswordError(error)) {
    return ChangeDeveloperPasswordErrorCodes.INCORRECT_CURRENT_PASSWORD;
  }

  if (isNetworkError(error)) {
    return ChangeDeveloperPasswordErrorCodes.NET_ERR;
  }

  return ChangeDeveloperPasswordErrorCodes.UNKNOWN;
};

const isAccountNotFoundError = errorCodeIs(ResetDeveloperPasswordErrorCodes.ACCOUNT_NOT_FOUND);

export const handleResetDeveloperPasswordError = (error: AxiosError): ResetDeveloperPasswordErrorCodes => {
  if (isAccountNotFoundError(error)) {
    return ResetDeveloperPasswordErrorCodes.ACCOUNT_NOT_FOUND;
  }

  if (isNetworkError(error)) {
    return ResetDeveloperPasswordErrorCodes.NET_ERR;
  }

  return ResetDeveloperPasswordErrorCodes.UNKNOWN;
};

const fixPhoneNumber = (phone = ''): string => (phone.startsWith('+') ? phone : `+55 ${phone}`);

export const toDeveloper = (developer: Developer): Developer => {
  return {
    ...developer,
    phone: fixPhoneNumber(developer.phone),
    photo: developer.photo ? getStaticHostURL(developer.photo, StoragePath.ProfileAvatar) : undefined,
  };
};

export const handleUpdateDeveloperError = (error: AxiosError): UpdateDeveloperErrorCodes => {
  if (isSlugConflictError(error)) {
    return UpdateDeveloperErrorCodes.SLUG_ALREADY_EXISTS;
  }

  return UpdateDeveloperErrorCodes.UNKNOWN;
};
